class ScrollToTopButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.progressPath = this.querySelector('.progress-circle path');
    this.pathLength = this.progressPath.getTotalLength();
    this.progressPath.style.strokeDasharray = this.pathLength + ' ' + this.pathLength;
    this.progressPath.style.strokeDashoffset = this.pathLength;
    this.progressPath.getBoundingClientRect();

    const buttons = this.querySelectorAll('button');
    [...buttons].forEach((button) => button.addEventListener('click', this.handleScrollTop.bind(this)));

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.calculatorProgressPathPercent(scrollTop);
    if (scrollTop > 400) {
      requestAnimationFrame(this.show.bind(this));
    } else{
      requestAnimationFrame(this.hide.bind(this));
    }
  }

  calculatorProgressPathPercent(scrollTop) {
    let fullHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
    let height = fullHeight - window.innerHeight ;
    let progress = this.pathLength - (scrollTop * this.pathLength/height);

    this.progressPath.style.strokeDashoffset = progress;
  }

  handleScrollTop(event) {
    event.preventDefault();
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  hide() {
    this.classList.remove('active');
  }

  show() {
    this.classList.add('active');
  }
}

customElements.define('scroll-top-button', ScrollToTopButton);